import IO from "./core/IO";
import View from "./core/View";
import { getScrollTop } from "./utils/dom";


export default class NotLocomotiveScroll {
    constructor($el, scrollCallback = () => {}) {
        // Set scroll container
        this.$scrollContainer = $el;

        // Set views array
        this.views = [];

        // Scroll values
        this.scroll = {
            direction: 1,
            last: 0,
            current: 0
        }

        //callback
        this.scrollCallback = scrollCallback

        // Setup
        if (!this.$scrollContainer) return;
        this.init();
    }


    ////////////////////
    // Lifecycle
    ////////////////////
    /**
     * Init
     */
    init() {
        // Retrieve views
        const $views = this.$scrollContainer.querySelectorAll("[data-nls-view]");

        // For each view create a View instance
        let index = 0;
        while (index < $views.length) {
            const $view = $views[index];

            const viewInstance = new View($view, index);
            this._subscribeView(index, viewInstance);

            index++;
        }

        // Use intersection observer to enable/disable views
        this.IOInstance = new IO(this.views)

        // Set default direction
        this._setCssDirection()
    }

    /**
     * Destroy
     */
    destroy() {
        this.stop();
        this.IOInstance.destroy();
        this._unsubscribeAllViews();
    }

    ////////////////////
    // Events
    ////////////////////
    _bindEvents() {
        this._onScroll = this._onScroll.bind(this);
        this._onResize = this._onResize.bind(this);

        window.addEventListener("scroll", this._onScroll);
        window.addEventListener("resize", this._onResize);

    }

    _unbindEvents() {
        window.removeEventListener("scroll", this._onScroll);
        window.removeEventListener("resize", this._onResize);
    }


    ////////////////////
    // Controls
    ////////////////////
    /**
     * Start scroll listener
     */
    start() {
        this._bindEvents();
    }

    /**
     * Stop scroll listener
     */
    stop() {
        this._unbindEvents();
    }


    ////////////////////
    // Views
    ////////////////////
    /**
     * Subscribe view
     * @param {number} : View index | {object} : View
     */
    _subscribeView(id, obj) {
        this.views.push({ id, obj });
    }

    /**
     * Unsubscribe specific view
     * @param {number} : View index | {object} : View
     */
    _unsubscribeView(id) {
        const savedViews = [];

        let index = 0;
        while (index < this.views.length) {
            const view = this.views[index];

            if (view.id != id) {
                // Keep view
                savedViews.push(view);
            } else {
                this.IOInstance.unobserve(view.obj.$view)
                view.obj.destroy();
            }

            index++;
        }

        // Replace array
        this.views = savedViews;
    }

    /**
     * Unsubscribe all views
     */
    _unsubscribeAllViews() {
        let index = 0;
        while (index < this.views.length) {
            const view = this.views[index];
            view.obj.destroy();
            index++;
        }

        // clear array
        this.views = [];
    }


    ////////////////////
    // Callbacks
    ////////////////////
    /**
     * Scroll callback
     */
    _onScroll() {
        // Store scroll values
        this.scroll.last = this.scroll.current
        this.scroll.current = getScrollTop()

        // Set scroll direction
        this._setScrollDirection()

        // Launch scroll function for each views
        let index = 0;
        while (index < this.views.length) {
            const $view = this.views[index];
            $view.obj.onScroll();
            index++;
        }

        this.scrollCallback && this.scrollCallback()
    }

    /**
     * Resize callback
     * Launch resize function for each views
     */
     _onResize() {
        let index = 0;
        while (index < this.views.length) {
            const $view = this.views[index];
            $view.obj.onResize();
            index++;
        }
    }


    ////////////////////
    // Scroll Direction
    ////////////////////
    /**
     * Set Scroll Direction
     */
    _setScrollDirection() {
        // Set direction
        const distance = this.scroll.current - this.scroll.last
        const direction = (distance) / Math.abs(distance) || 1;
        this.scroll.direction = direction;

        // Set css direction
        this._setCssDirection(direction)
    }

    /**
     * Set Css Direction
     * @param {number} : computed direction
     * Set css var on documentElement
     */
     _setCssDirection(direction = 1) {
        document.documentElement.style.setProperty("--nls-direction", direction);
    }
}
